/*************************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 *  NOTICE:  All information contained herein is, and remains
 *  the property of Adobe and its suppliers, if any. The intellectual
 *  and technical concepts contained herein are proprietary to Adobe
 *  and its suppliers and are protected by all applicable intellectual
 *  property laws, including trade secret and copyright laws.
 *  Dissemination of this information or reproduction of this material
 *  is strictly forbidden unless prior written permission is obtained
 *  from Adobe.
 **************************************************************************/
// Types related to the libraries and document assets data models
/**
 * TODO: Should pull these in from the Libraries API type definitions
 */
export var ElementType;
(function (ElementType) {
    ElementType["animation"] = "application/vnd.adobe.element.animation+dcx";
    ElementType["audio"] = "application/vnd.adobe.element.audio+dcx";
    ElementType["brush"] = "application/vnd.adobe.element.brush+dcx";
    ElementType["characterstyle"] = "application/vnd.adobe.element.characterstyle+dcx";
    ElementType["color"] = "application/vnd.adobe.element.color+dcx";
    ElementType["colortheme"] = "application/vnd.adobe.element.colortheme+dcx";
    ElementType["component"] = "application/vnd.adobe.element.component+dcx";
    ElementType["font"] = "application/vnd.adobe.element.font+dcx";
    ElementType["gradient"] = "application/vnd.adobe.element.gradient+dcx";
    ElementType["graphic"] = "application/vnd.adobe.element.image+dcx";
    ElementType["layerstyle"] = "application/vnd.adobe.element.layerstyle+dcx";
    ElementType["light"] = "application/vnd.adobe.element.light+dcx";
    ElementType["look"] = "application/vnd.adobe.element.look+dcx";
    ElementType["material"] = "application/vnd.adobe.element.material+dcx";
    ElementType["model"] = "application/vnd.adobe.element.3d+dcx";
    ElementType["mogrt"] = "application/vnd.adobe.element.graphic+dcx";
    ElementType["multicolorswatch"] = "application/vnd.adobe.element.multicolorswatch+dcx";
    ElementType["paragraphstyle"] = "application/vnd.adobe.element.paragraphstyle+dcx";
    ElementType["pattern"] = "application/vnd.adobe.element.pattern+dcx";
    ElementType["template"] = "application/vnd.adobe.element.template+dcx";
    ElementType["text"] = "application/vnd.adobe.element.text+dcx";
    ElementType["video"] = "application/vnd.adobe.element.video+dcx";
    ElementType["artifact"] = "application/vnd.adobe.element.artifact+dcx";
})(ElementType || (ElementType = {}));
/**
 * TODO: Should pull these in from the Libraries API type definitions
 */
export var Relationship;
(function (Relationship) {
    Relationship["primary"] = "primary";
    Relationship["rendition"] = "rendition";
})(Relationship || (Relationship = {}));
